import React, {
  useContext,
  useEffect, useRef, useState
} from 'react';
import { ConversationsList } from './Conversations';
import { CLOSE_CAF_METHOD, PRE_RULES } from '../../config/caf';
import { CAFModalHandlers } from '../../types/caf';
import Throbber from '../Throbber/Throbber';
import CloseModal from '../SVG/Caf/CloseButton';
import Text from './Conversations/Text';
import GlobalContext from '../../contexts/GlobalContext';

type Props = {
  handlers: CAFModalHandlers;
};

export const CAFContainer = (props: Props): JSX.Element => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const hasConversation = props.handlers.cafState?.conversations?.length;
  const handleCloseCaf = (source: string): void => {
    props.handlers.closeCAFModal(source);
  };

  useEffect(() => {
    setTimeout(() => {
      props.handlers.scrollToBottom(modalRef);
    }, 1000);

    setTimeout(() => {
      if (modalRef.current) {
        setHeight(modalRef.current.offsetHeight);
      }
    }, 100);
  }, [props.handlers.cafState]);

  return (
    <div className={`caf-modal ${props.handlers.cafState.isModalOpen ? 'show' : 'hide'}`}>
      <div className="overlay" data-testid='caf-close-button' onClick={(): void => handleCloseCaf(CLOSE_CAF_METHOD.SWIPE)}></div>
      <div className = "caf-modal__content" style = {{ height: height + (hasConversation ? 173 : 85) }} >
        { hasConversation ? <CAFStickyComponent handlers={ props.handlers } /> : <CloseModal handleCloseCaf={handleCloseCaf} />}
        <div ref={modalRef} className="caf-desktop-width">
          {hasConversation ?
           <ConversationsList
           conversations={props.handlers.cafState?.conversations}
           handlers={props.handlers}
           modalRef={modalRef}
           setHeight={setHeight}
         /> : <Throbber />}
        </div>
      </div>
    </div>
  );
};

const CAFStickyComponent = (props: Props): JSX.Element => {
  const handleCloseCaf = (source: string): void => {
    props.handlers.closeCAFModal(source);
  };
  const { globalContext } = useContext(GlobalContext);
  const totalSteps = Object.keys(PRE_RULES).length - 1;
  const currentStep = props.handlers.cafState.conversations.length - 1;

  return (
    <div className='caf-modal__head'>
    <CloseModal handleCloseCaf={ handleCloseCaf }/>
    <Text headings ={globalContext.i18n.getText('caf_welcome_heading')} headingClass = 'caf__mainheading' />
    <Text headings={ globalContext.i18n.getText('caf_welcome_subheading')} headingClass='caf__subheading' />
    <div className="steps-indicator caf-steps-spacing" >
      <ul>
      {
      Array.from({ length: totalSteps }).map((_, index) => (
        <li key= { index } className = {`step ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`} ></li>
      ))}
      </ul>
    </div>
    </div>);
};
